import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import {
  GeneralFacilityType,
  UseOrNot,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { labelids } from "../../assets/data/TkExplanationProperty";

const stepperData = ["施設情報・職員情報", "届出内容確認", "機構へ提出"];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050101_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "引継ぎコード",
    keyword: "transferCode",
    radioPropsList: TkGetCodeList(UseOrNot),
    type: "transferCodeText",
    isShowInput: "none",
    helpicon: true,
    helpText: (
      <>
        引継ぎコードは、当該施設を経営していた前の共済契約者から確認して入力してください。
        <br />
        引継ぎコードとは、経営移管や吸収合併の場合において、前の共済契約者で経営していた施設・事業、職員の情報を引き継ぐためのコードです。
        <br />
        引継ぎコードを登録しない場合は、在籍している職員の退職手当金の算定が正しくできなくなりますので、必ず登録をしてください。
      </>
    ),
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "基本情報",
  },
  {
    title: "新設・申出年月日",
    keyword: "applyDate",
    type: "date",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        施設区分が「社会福祉施設等」の場合は、指定通知または許認可書等に記載されている指定日、事業開始年月日と同日としてください。「特定介護保険施設」、「申出施設等」の場合は共済契約の対象施設としたい日となります。
        <br />
        日付は、直接入力するか、「カレンダーボタン」にて選択してください。
        <br />
        ※入力日によっては、登録できない場合があります。
      </>
    ),
  },
  {
    title: "施設種類",
    keyword: "facilityKind",
    requiredIcon: true,
    type: "facilityType",
    isSCRC030001: false,
    helpicon: true,
    isResisterApplyFlg: true,
    helpText:
      "登録する施設・事業の種類（保育所、幼保連携型認定こども園、特別養護養護老人ホーム等）を選択してください。",
  },
  {
    title: "施設区分",
    keyword: "facilityKbn",
    requiredIcon: true,
    type: "textWithExplanation",
    explan:
      "当該施設・事業については、一人当たりの掛金は{$1}円（単位掛金額×３）が必要となります。",
    isShowexplan: false,
    helpicon: true,
    helpText: (
      <>
        施設種類・サービス種類に応じた施設区分を表示しています。
        <br />
        施設区分に応じて掛金が変わります。
        <br />
        詳しくは
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫施設区分について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    title: "施設名称",
    keyword: "facilityName",
    requiredIcon: true,
    type: "label",
    inputProps: { maxLength: 85 },
    helpicon: true,
    helpText: (
      <>
        施設・事業所の正式な名称を入力してください。
        <br />
        ※このページの最後で添付いただく「当該施設・事業を経営している証拠書類」に記載されている名称と同一となるように転記してください。
      </>
    ),
  },
  {
    title: "郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    requiredIcon: true,
    inputProps: { maxLength: 7 },
    helpicon: true,
    helpText: (
      <>
        施設・事業所の正式な所在地の郵便番号を入力してください。
        <br />
        ※このページの最後で添付いただく「当該施設・事業を経営している証拠書類」に記載されている郵便番号と同一となるように転記してください。
      </>
    ),
  },
  {
    title: "所在地",
    keyword: "address",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        施設・事業所の正式な所在地を入力してください。
        <br />
        ※このページの最後で添付いただく「当該施設・事業を経営している証拠書類」に記載されている所在地と同一となるように転記してください。
      </>
    ),
  },
  {
    keyword: "title4",
    type: "lineTitle",
    lineTitle: "この施設で使用する手当を選択してください。",
  },
  {
    title: "「俸給の調整額」対象手当",
    keyword: "salaryAdjustmentAmount",
    type: "nodeInLine",
    helpicon: true,
    helpText: (
      <>
        「俸給の調整額」対象手当として当機構が認めたものです。登録されている手当以外の金額は計上することができません。未登録の場合は登録申請が必要です。
        <br />
        俸給の調整額については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給の調整額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    keyword: "title5",
    type: "lineTitle",
    lineTitle: "職員数情報",
  },
  {
    title: "入所定員（利用定員）",
    keyword: "admissionCapacityNum",
    type: "amount",
    innerText: "人",
    onlyNumber: true,
    inputProps: { maxLength: 10 },
    requiredIcon: true,
    helpicon: true,
    helpText:
      "法令上定められた基準数（許認可・届出書記載事項）です。なお、国の指定がない施設・事業の場合は「0」と入力してください。",
  },
  {
    title: "職員配置基準数",
    keyword: "staffBaseNum",
    type: "amount",
    innerText: "人",
    onlyNumber: true,
    inputProps: { maxLength: 10 },
    requiredIcon: true,
    helpicon: true,
    helpText:
      "法令上定められた基準数（許認可・届出書記載事項）です。なお、国の指定がない施設・事業の場合は「0」と入力してください。",
  },
  {
    title: "申込時職員総数",
    keyword: "totalStaffNum",
    type: "text",
    helpicon: true,
    helpText: (
      <>
        加入対象の職員と加入対象外の職員を合わせた申込時の当該施設の職員総数です。
        <br />
        ※加入要件については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    title: "加入職員数",
    keyword: "joinStaffNum",
    type: "text",
  },
  {
    title: "雇用契約上の雇用期間1年未満職員数",
    keyword: "yearJoindisableStaffNum",
    type: "amount",
    innerText: "人",
    onlyNumber: true,
    inputProps: { maxLength: 3 },
    helpicon: true,
    helpText: (
      <>
        雇用契約上の雇用期間が１年未満の加入対象外となる職員数です。所定労働時間の2/3未満の職員の両方に該当する場合は、雇用期間１年未満に計上してください。
        <br />
        ※加入要件については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご参照ください。
      </>
    ),
  },
  {
    title: "雇用契約上の労働時間２/３未満職員数",
    keyword: "timeJoindisableStaffNum",
    type: "amount",
    innerText: "人",
    onlyNumber: true,
    inputProps: { maxLength: 3 },
    helpicon: true,
    helpText: (
      <>
        雇用契約上の労働時間が正職員の所定労働時間の2/3未満の加入対象外となる職員数です。雇用期間1年未満の職員の両方に該当する場合は、雇用期間１年未満に計上してください。
        <br />
        ※加入要件については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご参照ください。
      </>
    ),
  },
  {
    title: "特定職員数",
    keyword: "specifiedStaffNum",
    type: "amount",
    innerText: "人",
    onlyNumber: true,
    inputProps: { maxLength: 10 },
    showLine: false,
  },
  {
    title: "措置入所障害児関係業務従事職員数",
    keyword: "hcStaffNum",
    type: "amount",
    onlyNumber: true,
    innerText: "人",
    inputProps: { maxLength: 10 },
    showLine: false,
  },
  {
    keyword: "title6",
    type: "lineTitle",
    lineTitle:
      "申込施設が「特定介護保険施設等」：又は「申出施設等」に該当する場合は下記にもご記入ください。",
  },
  {
    title: "給与支払遅延の有無",
    keyword: "salaryPaymentDelayFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "給与の支払い遅延の有無です。有の場合は、施設の登録ができません。",
  },
  {
    title: "該当施設等が共済契約を締結していたことの有無",
    keyword: "hadContractFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    requiredIcon: true,
    disabled: false,
  },
  {
    title: "解除年月日",
    keyword: "pastContractCancelDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    helpicon: true,
    helpText:
      "過去に共済契約を締結していたことがある場合における解除年月日です。",
    disabled: false,
  },
  {
    keyword: "title7",
    type: "lineTitle",
    lineTitle: "添付書類をアップロードしてください。",
  },
  {
    title: "当該施設・事業を経営している証拠書類",
    keyword: "documentaryEvidence",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        登録施設の情報（施設等の名称、所在地、種類、入所（利用）定員、事業開始年月日）が確認できる次のいずれかの書類
        <br />
        （１）「許認可書」（写）又は「指定通知書」（写）
        <br />
        （２）「許可書」（写）又は「許認可書」（写）
        <br />
        （３）その他、業務委託契約書等
        <br />
        （４）（１）～（３）に該当する書類がない場合は、都道府県知事等が発行する証明書
        <br />
        （５）法令等により、許認可、届出の必要がない場合は、次のいずれかの書類
        <br /> ①「法人の定款」（写）
        <br />
        ②「定款変更申請書」（写）
        <br />
        ③「履歴事項全部証明書」（写）
      </>
    ),
  },
  {
    keyword: "title8",
    type: "lineTitle",
    lineTitle:
      "入力した内容を確認後、間違いが無ければ「登録」ボタンを押してください。",
  },
];
const schema: any = {
  applyDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  facilityKind: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  facilityName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  zipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  address: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: !data?.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : "",
        city: !data?.city
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.city.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : // eslint-disable-next-line no-control-regex
          !data.city.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
        address: !data?.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.address.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
          : // eslint-disable-next-line no-control-regex
          !data.address.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
      };

      if (
        error.prefectures !== "" ||
        error.city !== "" ||
        error.address !== ""
      ) {
        return JSON.stringify(error);
      }
    },
  },
  admissionCapacityNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "10"),
    },
  },
  staffBaseNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "10"),
    },
  },
  yearJoindisableStaffNum: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 3,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "3"),
    },
  },
  timeJoindisableStaffNum: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 3,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "3"),
    },
  },
  specifiedStaffNum: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "10"),
    },
  },
  hcStaffNum: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "10"),
    },
  },
  documentaryEvidence: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const dynamicSchema: any = {
  salaryPaymentDelayFlg: { required: TkPropertyMessageGet("TKMSG_SCR0044E") },
  hadContractFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

// 以下の職種が選択された場合に、「特定職員数」の項目を表示する
const showNumberOfSpecificEmployees: string[] = [
  GeneralFacilityType["障害児通所支援事業"],
  GeneralFacilityType["老人居宅介護等事業（ホームヘルプ）"],
  GeneralFacilityType["小規模多機能型居宅介護事業"],
  GeneralFacilityType["認知症対応型老人共同生活援助事業（グループホーム）"],
  GeneralFacilityType["居宅介護事業"],
  GeneralFacilityType["重度訪問介護事業"],
  GeneralFacilityType["同行援護事業"],
  GeneralFacilityType["行動援護事業"],
  GeneralFacilityType["療養介護事業"],
  GeneralFacilityType["生活介護事業"],
  GeneralFacilityType["自立訓練事業"],
  GeneralFacilityType["就労移行支援事業"],
  GeneralFacilityType["就労継続支援事業"],
  GeneralFacilityType["就労定着支援事業"],
  GeneralFacilityType["自立生活援助事業"],
  GeneralFacilityType["共同生活援助事業（グループホーム）"],
  GeneralFacilityType["移動支援事業"],
  GeneralFacilityType["短期入所事業（ショートステイ）"],
  GeneralFacilityType["重度障害者等包括支援事業"],
];

// 以下の職種が選択された場合に、「措置入所障害児関係業務従事職員数」の項目を表示する
const showNumberOfDisabledChildSaff: string[] = [
  GeneralFacilityType["障害児入所施設"],
];

export {
  schema,
  stepperData,
  fakeTableList,
  showNumberOfSpecificEmployees,
  showNumberOfDisabledChildSaff,
  dynamicSchema,
};
